import { defineMessages } from 'react-intl';

export default defineMessages({
  optionTitleLeft: 'All',
  optionTitleRight: 'Stable Coins',
  noDataTitle: 'There are no currencies matching the parameters',

  availableToDeposit: 'Available to deposit',
  myDeposits: 'My deposits',
});
